import React, { useEffect, useState } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import { useFormContext, Controller } from "react-hook-form";
import {
    allowOnlyNumbers,
    formatPhoneNumber,
    getAgencias,
    getSupervisor,
    getEstudiantePorTelefono,
    getClientById,
} from "../utils/utils";

const PerfilBasicoCliente = ({ parentCallback, disabled }) => {
    const history = useHistory();
    const [estudiante, setEstudiante] = useState([]);
    const [agencias, setAgencias] = useState([]);
    const [supervisorList, setSupervisorList] = useState([]);
    const [telefono, setTelefono] = useState("");
    let firstName = React.createRef();
    let { id } = useParams();

    const {
        register,
        formState: { errors },
    } = useFormContext();

    parentCallback(id);

    //console.log(errors);

    useEffect(() => {
        getAgencias().then((agencies) => {
            setAgencias(agencies);
        });
        id &&
            getClientById(id).then((client) => {
                setEstudiante(client);
            });
        getSupervisor().then((supervisorList) => {
            setSupervisorList(supervisorList);
        });
    }, []);

    function phoneValidation(e) {
        if (e.target.value.length === 12) {
            getEstudiantePorTelefono(e.target.value).then((estudiante) => {
                if (estudiante.length > 0) {
                    if (
                        window.confirm(
                            "Este número de teléfono ya se encuentra registrado ¿Desea editar el registro existente?"
                        )
                    ) {
                        history.push("/estudiante/edit/" + estudiante[0].cli_id);
                    } else {
                        setTelefono("");
                    }
                }
            });
        }
    }

    return (
        <React.Fragment>
            {((estudiante[0] && id) || id === undefined) && (
                <React.Fragment>
                    <div className="row align-items-center">
                        <div className="col-6">
                            <h3>
                                <i className="bi-person"></i>
                                <strong>
                                    {id === undefined ? "Nuevo estudiante" : "Editar estudiante"}
                                </strong>
                            </h3>
                        </div>
                        {disabled && (
                            <div className="col-6 text-end">
                                <Link to={"/estudiante/edit/" + id}>
                                    <button type="button" className="btn btn-sm btn-outline-dark">
                                        <i className="bi bi-pen"></i> Editar
                                    </button>
                                </Link>
                            </div>
                        )}
                    </div>

                    <div className="card my-5">
                        <div className="card-header">
                            <strong>Datos básicos: </strong>
                        </div>
                        <div className="card-body">
                            <div className="row py-2">
                                <div className="form-group col-md-2">
                                    <label htmlFor="nombre">Creado por:</label>
                                    <input disabled type="text" className="form-control" id="createdBy"
                                        defaultValue={
                                            id === undefined && telefono === ""
                                                ? ""
                                                : estudiante[0] && estudiante[0].usu_username
                                        }
                                    />
                                </div>
                                <div className="form-group col-md-5">
                                    <label htmlFor="nombre">Nombres</label>
                                    <input disabled={disabled} type="text" className="form-control"
                                        onKeyPress={(e) => {
                                            e.key === "Enter" && e.preventDefault();
                                        }}
                                        id="firstName"
                                        defaultValue={
                                            id === undefined && telefono === ""
                                                ? ""
                                                : estudiante[0] && estudiante[0].cli_nombre
                                        }
                                        ref={firstName}
                                        {...register("firstName", { required: false, maxLength: 80 })}
                                    />
                                </div>
                                <div className="form-group col-md-5">
                                    <label htmlFor="lastName">Apellidos</label>
                                    <input disabled={disabled} type="text" className="form-control"
                                        onKeyPress={(e) => {
                                            e.key === "Enter" && e.preventDefault();
                                        }}
                                        id="lastName"
                                        defaultValue={
                                            id === undefined && telefono === ""
                                                ? ""
                                                : estudiante[0] && estudiante[0].cli_apellido
                                        }
                                        {...register("lastName", { required: false, maxLength: 80 })}
                                    />
                                </div>
                            </div>
                            <div className="row py-2">
                                <div className="form-group col-md-4">
                                    <label htmlFor="phone">Telefono</label>
                                    <input
                                        onInput={(e) => formatPhoneNumber(e)}
                                        onKeyUp={(e) => {
                                            e.key === "Enter" && e.preventDefault();
                                            phoneValidation(e);
                                        }}
                                        type="text" className="form-control" id="phone" disabled={disabled}
                                        defaultValue={
                                            id === undefined ? "" : estudiante[0].cli_telefono
                                        }
                                        {...register("phone", { required: true, maxLength: 80 })}
                                    />
                                </div>
                                <div className="form-group col-md-4">
                                    <label htmlFor="email">Email</label>
                                    <input disabled={disabled} type="email" className="form-control"
                                        onKeyPress={(e) => {
                                            e.key === "Enter" && e.preventDefault();
                                        }}
                                        id="email"
                                        defaultValue={id === undefined ? "" : estudiante[0].cli_email}
                                        {...register("email", {
                                            required: false,
                                            pattern: /^\S+@\S+$/i,
                                        })}
                                    />
                                </div>
                                <div className="form-group col-md-4">
                                    <label htmlFor="birthDate">Fecha de nacimiento</label>
                                    <input disabled={disabled} type="date" className="form-control" 
                                        onKeyPress={(e) => {
                                            e.key === "Enter" && e.preventDefault();
                                        }}
                                        id="birthDate"
                                        defaultValue={
                                            id === undefined
                                                ? ""
                                                : estudiante[0].cli_dob !== null
                                                    ? estudiante[0].cli_dob.substring(0, 10)
                                                    : ""
                                        }
                                        {...register("birthDate", { required: false })}
                                    />
                                </div>
                            </div>
                            <div className="row py-2">
                                <div className="form-group">
                                    <label htmlFor="address">Dirección</label>
                                    <input disabled={disabled} 
                                        onKeyPress={(e) => {
                                            e.key === "Enter" && e.preventDefault();
                                        }}
                                        type="text" className="form-control" id="address"
                                        defaultValue={
                                            id === undefined ? "" : estudiante[0].cli_direccion
                                        }
                                        {...register("address", { required: false, maxLength: 80 })}
                                    />
                                </div>
                            </div>
                            <div className="row py-2">
                                <div className="form-group col-3">
                                    <label htmlFor="city">Ciudad</label>
                                    <input disabled={disabled}
                                        onKeyPress={(e) => {
                                            e.key === "Enter" && e.preventDefault();
                                        }}
                                        type="text" className="form-control" id="city"
                                        defaultValue={id === undefined ? "" : estudiante[0].cli_ciudad}
                                        {...register("city", { required: false, maxLength: 80 })}
                                    />
                                </div>
                                <div className="form-group col-md-4">
                                    <label htmlFor="state">Estado</label>
                                    <input disabled={disabled}
                                        onKeyPress={(e) => {
                                            e.key === "Enter" && e.preventDefault();
                                        }}
                                        type="text" className="form-control" id="state"
                                        defaultValue={id === undefined ? "" : estudiante[0].cli_estado}
                                        {...register("state", { required: false, maxLength: 80 })}
                                    />
                                </div>
                                <div className="form-group col-md-2">
                                    <label htmlFor="zip">Zip</label>
                                    <input disabled={disabled} 
                                        onKeyPress={(e) => {
                                            e.key === "Enter" && e.preventDefault();
                                        }}
                                        type="text" className="form-control" id="zip"
                                        defaultValue={id === undefined ? "" : estudiante[0].cli_zip}
                                        {...register("zip", { required: false, maxLength: 80 })}
                                    />
                                </div>
                                <div className="form-group col-3">
                                    <label htmlFor="studentState">Agencia</label>
                                    <div className="form-group">
                                        {agencias.length > 0 ? (
                                            <select {...register("agencia")} disabled={disabled} id="agencia" className="form-select">
                                                {agencias.map((agencia, index) => {
                                                    if (agencia.age_status === "1") {
                                                        return (
                                                            <option
                                                                selected={
                                                                    estudiante[0] &&
                                                                    agencia.age_id === estudiante[0].cli_agencia_crea
                                                                }
                                                                key={agencia.age_id}
                                                                value={agencia.age_id}
                                                            >
                                                                {agencia.age_nombre}
                                                            </option>
                                                        );
                                                    }
                                                })}
                                            </select>
                                        ) : (
                                            <select className="form-select">
                                                <option>No disponible</option>
                                            </select>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="row py-2">
                                <div className="form-group col-md-2">
                                    <label htmlFor="genre">Sexo</label>
                                    <select
                                        {...register("genre", { required: false, maxLength: 80 })}
                                        disabled={disabled}
                                        id="genre"
                                        className="form-select"
                                    >
                                        <option>M</option>
                                        <option>F</option>
                                    </select>
                                </div>
                                <div className="form-group col-md-2">
                                    <label htmlFor="eyesColor">Ojos</label>
                                    <select {...register("eyesColor", { required: false, maxLength: 80 })}
                                        disabled={disabled} id="eyesColor" className="form-select">
                                        <option>Cafe</option>
                                        <option>Azul</option>
                                        <option>Verde</option>
                                    </select>
                                </div>
                                <div className="form-group col-md-2">
                                    <label htmlFor="feets">Pies</label>
                                    <input onInput={(e) => allowOnlyNumbers(e)} disabled={disabled}
                                        onKeyPress={(e) => {
                                            e.key === "Enter" && e.preventDefault();
                                        }}
                                        type="text" className="form-control" id="feets"
                                        defaultValue={
                                            id === undefined ? "" : estudiante[0].cli_estatura_pies
                                        }
                                        {...register("feetHeight", { required: false, maxLength: 80 })}
                                    />
                                </div>
                                <div className="form-group col-md-2">
                                    <label htmlFor="inches">Pulgadas</label>
                                    <input onInput={(e) => allowOnlyNumbers(e)} disabled={disabled}
                                        onKeyPress={(e) => {
                                            e.key === "Enter" && e.preventDefault();
                                        }}
                                        type="text" className="form-control" id="inches"
                                        defaultValue={
                                            id === undefined ? "" : estudiante[0].cli_estatura_pulgadas
                                        }
                                        {...register("inchHeight", { required: false, maxLength: 80 })}
                                    />
                                </div>
                                <div className="form-group col-md-3">
                                    <label htmlFor="studentState">Supervisor</label>
                                    <div className="form-group">
                                        {supervisorList.length > 0 ? (
                                            <select {...register("studentStatus", { required: true }) } disabled={disabled} id="studentStatus" className="form-select" >
                                                <option key='' value='' ></option>
                                                {supervisorList.map((supervisor, index) => (
                                                    <option
                                                        selected={ estudiante[0] && supervisor.id_supervisor === estudiante[0].id_status_student }
                                                        key={supervisor.id_supervisor}
                                                        value={supervisor.id_supervisor}
                                                    >                  
                                                        {supervisor.name_supervisor}
                                                    </option>
                                                ))}
                                            </select>
                                        ) : (
                                            <select className="form-select">
                                                <option>No disponible</option>
                                            </select>
                                        )}
                                    </div>
                                </div>
                                <div className="form-group col-md-1">
                                    {disabled && (
                                        
                                        
                                       
                                        <div className="col-6 text-end">
                                            <label htmlFor="cel"></label>
                                            <a href={"https://api.whatsapp.com/send?phone=1" + estudiante[0].cli_telefono.replace(/-/g, "")}   target="blank">
                                                <button type="button" className="btn btn-sm btn-success">
                                                    <i className="bi bi-telephone"></i> Whatsapp
                                                </button>
                                            </a>
                                        </div>   
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            )}
        </React.Fragment>
    );
};

export default PerfilBasicoCliente;
